export default __webpack_public_path__ + "static/media/arrow.03642e82.svg";